import { BaseResource } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export class ProofOfDeliveryInformationResource extends BaseResource {
    pk() {
        return this.applicationId?.toString();
    }
}
ProofOfDeliveryInformationResource.urlRoot = legacyApiResourceUrl("ProofOfDelivery/Info");
//# sourceMappingURL=ProofOfDeliverySmsResources.js.map